var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
var ToggleEditable = /** @class */ (function (_super) {
    __extends(ToggleEditable, _super);
    function ToggleEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToggleEditable.prototype.render = function () {
        var options = this._args.options;
        var firstElement = this.getFirstInput();
        var secondElement = this.getSecondInput();
        firstElement.value = options[0].value;
        secondElement.value = options[1].value;
        firstElement.parentElement.querySelector('.toggle__label').innerHTML = options[0].label;
        secondElement.parentElement.querySelector('.toggle__label').innerHTML = options[1].label;
        if (ToggleEditable.getTrueValues().includes(options[0].label.toString().toLowerCase())) {
            firstElement.parentElement.querySelector('.toggle__label').innerHTML = ToggleEditable.getDefaultTrueLabel();
            secondElement.parentElement.querySelector('.toggle__label').innerHTML = ToggleEditable.getDefaultFalseLabel();
        }
        else if (ToggleEditable.getFalseValues().includes(options[0].label.toString().toLowerCase())) {
            firstElement.parentElement.querySelector('.toggle__label').innerHTML = ToggleEditable.getDefaultFalseLabel();
            secondElement.parentElement.querySelector('.toggle__label').innerHTML = ToggleEditable.getDefaultTrueLabel();
        }
    };
    ToggleEditable.prototype.valueToInput = function (value) {
        // Shortroute, don't even show the modal, just toggle and save
        if (!this._args.showbuttons && value !== null) {
            var matched = false;
            var firstElement = this.getElement().querySelector('input[data-o1]');
            var secondElement = this.getElement().querySelector('input[data-o2]');
            if (firstElement.value.toString() === value.toString()) {
                secondElement.checked = true;
                matched = true;
            }
            if (secondElement.value.toString() === value.toString()) {
                firstElement.checked = true;
                matched = true;
            }
            // Mismatch of value and options
            if (!matched) {
                this.getTrueInput().checked = true;
            }
            this.save();
            this.close();
        }
    };
    ToggleEditable.prototype.getFalseInput = function () {
        if (ToggleEditable.getFalseValues().includes(this._args.options[0].value.toString().toLowerCase())) {
            return this.getFirstInput();
        }
        else {
            return this.getSecondInput();
        }
    };
    ToggleEditable.prototype.getTrueInput = function () {
        if (ToggleEditable.getTrueValues().includes(this._args.options[0].value.toString().toLowerCase())) {
            return this.getFirstInput();
        }
        else {
            return this.getSecondInput();
        }
    };
    ToggleEditable.prototype.getFirstInput = function () {
        return this.getElement().querySelector('input[data-o1]');
    };
    ToggleEditable.prototype.getSecondInput = function () {
        return this.getElement().querySelector('input[data-o2]');
    };
    ToggleEditable.prototype.getValue = function () {
        return this.getElement().querySelector('input:checked').value;
    };
    ToggleEditable.getTrueValues = function () {
        return ['true', 'yes', '1', 'on'];
    };
    ToggleEditable.getFalseValues = function () {
        return ['', '0', 'no', 'false', 'off'];
    };
    ToggleEditable.getDefaultTrueLabel = function () {
        return '<span class="dashicons dashicons-yes"></span>';
    };
    ToggleEditable.getDefaultFalseLabel = function () {
        return '<span class="dashicons dashicons-no"></span>';
    };
    ToggleEditable.prototype.getTemplate = function () {
        return "\n\t\t<label >\n\t\t\t<input type=\"radio\" name=\"toggle\" data-o1>\n\t\t\t<span class=\"toggle__label\"></span>\n\t\t</label>\n\t\t<label data-false>\n\t\t\t<input type=\"radio\" name=\"toggle\" data-o2>\n\t\t\t<span class=\"toggle__label\"></span>\n\t\t</label>";
    };
    ToggleEditable.prototype._setDefaults = function () {
        this._defaults.type = 'togglable';
        this._defaults.showbuttons = true;
    };
    return ToggleEditable;
}(AbstractEditable));
export default ToggleEditable;
